import { Button, Dialog, DialogActions, DialogContent, DialogTitle, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { handlingCatchError } from "../../Utils/ErrorHandling";
import { apiCommonTrigger } from "../../Utils/apiServicehelper";
import { Config } from "../../Utils/Config";
import { HubSpotForm } from "../../helpers/componentHelper";

export default function SubscriptionDialog({ packageDetail,onClose,isOpen }) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [plan,setPlan] = useState("annually")
    const [contactUsOpen, setContactUsOpen] = useState(false);

    const updateProSubscription = () => {
      if (localStorage.getItem("impersonated") === "true") {
        checkImpersonation();
      } else {
        setIsLoading(true);
        let inputData={   lookupkey: plan === "annually" ? packageDetail.ProLookupKey : packageDetail.QuartLookupKey,}
          apiCommonTrigger("post",`${Config.API_URL}/subscription/upgrade`,inputData)
          .then((res) => {
            if (res.status === 200) {
              setIsLoading(false);
              window.open(res.headers.location, "_self");
            } else {
              setIsLoading(false);
              handlingCatchError(res, navigate);
            }
          })
          .catch((err) => {
            setIsLoading(false);
            handlingCatchError(err, navigate);
          });
      }
    };
  const handleToggleChange = (e,plan)=>{
    if(plan !== null){
      setPlan(plan)
    }
  }

  return (
    <>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : null}
      <Dialog
        open={isOpen}
        className={"modal-custom-popup pro-subscription-modal"}
      >
        <form id="RVParkIQ_myaccount_form">
          <DialogTitle>{"Pro Subscription"}</DialogTitle>
          <DialogContent>
            <React.Fragment>
            <div className="feature-matrix price-info">
                 <ToggleButtonGroup
                   value={plan}
                   exclusive
                   onChange={handleToggleChange}
                   sx={{
                     backgroundColor: "#fff",
                     borderRadius: "20px",
                     padding: "2px",
                   }}>
                   <ToggleButton
                     value="annually"
                     sx={{
                       textTransform: "none",
                       border: "none",
                       "&.Mui-selected": {
                         backgroundColor: "#f15d47",
                         color: "white",
                         "&:hover": { backgroundColor: "#f15d47" },
                       },
                     }}>
                     Annually
                   </ToggleButton>
                   <ToggleButton
                     value="quarterly"
                     sx={{
                       textTransform: "none",
                       border: "none",
                       "&.Mui-selected": {
                         backgroundColor: "#f15d47",
                         color: "white",
                         "&:hover": { backgroundColor: "#f15d47" },
                       },
                     }}  >
                     Quarterly
                   </ToggleButton>
                 </ToggleButtonGroup>
               </div>
                {plan === "annually" &&(
              <p className="ft-14 text-center price">
                Starting at{" "}
               <b>
                {packageDetail.Currency +
                       packageDetail.ProSubscriptionPrice +
                      "/" +
                      packageDetail.Period}
                </b>
               
              </p>)}
              <p className="mt-2 ft-14">
                Get complete access to the entire application with the ability
                to create an unlimited number of market reports.
              </p>
              <Row>
                <Col xs={12} className="modal-pro-subscription">
                  <h6>Full RV Park Profile</h6>
                  <ul>
                    <li>Property Details</li>
                    <li>Amenities and Features</li>
                    <li>Rate Details</li>
                    {/* <li>Marketing</li> */}
                    <li>Ownership</li>
                    <li>Valuation and Debt</li>
                    <li>Transaction History</li>
                    <li>Seasonality</li>
                  </ul>
                </Col>
                <Col xs={12} className="modal-pro-subscription">
                  <h6>Market Dynamics Score</h6>
                  <ul>
                    <li>Market Demand Score</li>
                    <li>Market Supply Factors</li>
                  </ul>
                </Col>
                <Col xs={12} className="modal-pro-subscription">
                  <h6>Full Population Center Profile</h6>
                  <ul>
                    <li>RV Parks in market</li>
                    <li>Average price per night</li>
                    <li>Average size of park</li>
                    {/* <li>Rental availability</li> */}
                    <li>Population</li>
                    <li>Population density</li>
                    <li>Region Type</li>
                    <li>Income per capita</li>
                    {/* <li>Average fuel cost</li> */}
                    <li>Average age</li>
                    <li>Age cohorts</li>
                    {/* <li>Ethnicity</li>
                    <li>Ethnicity cohorts</li>
                    <li>Gender percentages</li> */}
                  </ul>
                  <h6>Unlimited Market Analysis Reports</h6>
                </Col>
              </Row>
            </React.Fragment>
          </DialogContent>
          <DialogActions className="pro-footer">
            <React.Fragment>
              <Button onClick={() => onClose()} className="reset-opt">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  if (plan === "annually") {
                    updateProSubscription();
                  } else {
                    setContactUsOpen(true);
                  }
                }}
                className="market-btn"
              >
                {plan === "annually" ? "Subscribe" : "Contact us"}
              </Button>
              <HubSpotForm contactUsOpen={contactUsOpen} setContactUsOpen={setContactUsOpen}/>
            </React.Fragment>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
